export default __webpack_public_path__ + "static/media/LFS_NSW2.e09365eb.png";